<div class="w-full">
  <ed-card
    [title]="title"
    [subtitle]="subtitle"
    [headerActions]="collapseButton"
    (click)="expandContent()"
    [style.cursor]="isContentCollapsed ? 'pointer' : 'default'"
  >
    <div
      [attr.id]="displayId ? id?.trim() + '-content' : null"
      class="flex flex-col gap-3 w-full h-full"
      [@expand]="isContentCollapsed ? 'collapsed' : 'expanded'"
    >
      <div class="mt-3">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
        @if (redirectUrl && redirectUrlDisplayText) {
          <a
            class="flex flex-row gap-1 anchor mt-3"
            href="{{ redirectUrl }}"
            target="_blank"
          >
            <span>{{ redirectUrlDisplayText }}</span>
            <mat-icon
              class="stroke-red-100 p-1"
              svgIcon="arrow-right"
            ></mat-icon>
          </a>
        }
      </div>
    </div>
  </ed-card>
  <ng-template #collapseButton>
    @if (tooltipText) {
      <ed-tooltip [tooltip]="tooltipText | transloco" position="left">
        <button
          class="arrow-square"
          edType="primary"
          [disabled]="disabled"
          [attr.id]="
            displayId && isContentCollapsed ? id?.trim() + '-expand-btn' : null
          "
          (click)="toggleContent(); $event.stopPropagation()"
          ed-button
        >
          <mat-icon
            class="stroke-white arrow"
            [svgIcon]="isContentCollapsed ? 'arrow-down' : 'arrow-up'"
          ></mat-icon>
        </button>
      </ed-tooltip>
    } @else {
      <button
        class="arrow-square"
        edType="primary"
        [disabled]="disabled"
        [attr.id]="
          displayId && isContentCollapsed ? id?.trim() + '-expand-btn' : null
        "
        (click)="toggleContent(); $event.stopPropagation()"
        ed-button
      >
        <mat-icon
          class="stroke-white arrow"
          [svgIcon]="isContentCollapsed ? 'arrow-down' : 'arrow-up'"
        ></mat-icon>
      </button>
    }
  </ng-template>
</div>
